<template>
  <span>
    {{ content }}
  </span>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      content: '>',
    };
  },
  watch: {
    active(isActive) {
      if (isActive) {
        this.content = '<';
      } else {
        this.content = '>';
      }
    },
  },
};
</script>
<style scoped>
span {
  display: inline-block;
  transform: rotate(90deg);
}
</style>
